import { ComponentContext, elementsToShapes, SeatingViewerContext } from '@wix/seating-common-components';
import React, { useMemo } from 'react';
import { Seat } from '../seat';
import { Area } from '../area';
import { Shapes } from '../shapes';
import s from './plan.scss';
var viewerComponents = {
    Seat: Seat,
    Area: Area,
    PointerArea: function () { return null; },
    SelectionMarker: function () { return null; },
};
export var Plan = function (_a) {
    var plan = _a.plan, svgViewBox = _a.svgViewBox, currentlyClickedPlaceId = _a.currentlyClickedPlaceId, selectedPlaceIds = _a.selectedPlaceIds, onPlaceClick = _a.onPlaceClick, placesStock = _a.placesStock, onPlaceMouseEnter = _a.onPlaceMouseEnter, onPlaceMouseLeave = _a.onPlaceMouseLeave;
    var shapes = useMemo(function () { return elementsToShapes(plan, true); }, [plan]);
    var seatingViewContextValue = useMemo(function () { return ({
        currentlyClickedPlaceId: currentlyClickedPlaceId,
        selectedPlaceIds: selectedPlaceIds,
        onPlaceClick: onPlaceClick,
        placesStock: placesStock,
        onPlaceMouseEnter: onPlaceMouseEnter,
        onPlaceMouseLeave: onPlaceMouseLeave,
    }); }, [currentlyClickedPlaceId, selectedPlaceIds, onPlaceClick, placesStock, onPlaceMouseEnter, onPlaceMouseLeave]);
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: s.plan, viewBox: svgViewBox },
        React.createElement(ComponentContext.Provider, { value: viewerComponents },
            React.createElement(SeatingViewerContext.Provider, { value: seatingViewContextValue },
                React.createElement(Shapes, { shapes: shapes })))));
};
//# sourceMappingURL=plan.js.map